import defaultState from './state';

const SET_CLASSCODE = (state, classCode) => {
  state.joiningOptions.classCode = classCode;
};

const SET_NEED_SALES = (state, value) => {
  state.joiningOptions.needSales = value;
};

const SET_INVITATION_TOKEN = (state, invToken) => {
  state.joiningOptions.invitationToken = invToken;
};

const SAVE_STUDENT_CLASSES = (state, classes) => {
  state.studentClasses = classes;
};

const SAVE_OPEN_ASSIGNMENTS = (state, list) => {
  state.openAssignments = list;
};

const SAVE_ALL_OPEN_ASSIGNMENTS = (state, list) => {
  state.allOpenAssignments = list;
};

const DESTROY_OPEN_ASSIGNMENTS = (state) => {
  state.openAssignments = [];
};

const DESTROY_ALL_OPEN_ASSIGNMENTS = (state) => {
  state.allOpenAssignments = [];
};

const DESTROY = (state) => {
  Object.keys(defaultState).forEach((key) => {
    state[key] = defaultState[key];
  });
};

export default {
    SET_CLASSCODE,
    SET_INVITATION_TOKEN,
    SAVE_STUDENT_CLASSES,
    SAVE_OPEN_ASSIGNMENTS,
    SAVE_ALL_OPEN_ASSIGNMENTS,
    DESTROY,
    DESTROY_OPEN_ASSIGNMENTS,
    DESTROY_ALL_OPEN_ASSIGNMENTS,
    SET_NEED_SALES,
};
